<template>
  <div class="signInRequired">
    <div :class="{signInCnt: true, register: type === 'register'}">
      <div class="backBtn" v-if="type === 'register'"
        v-on:click="back"></div>
      <div v-if="type === 'login'">
        <h3>Masuk</h3>
        <h4>Masuk ke Bumibutuhaksi.</h4>
      </div>
      <div class="forgotHeader" v-else-if="type === 'forgot'">
        <h3>Lupa Password</h3>
        <h4 v-if="emailSent">Link ganti password sudah terkirim.</h4>
        <h4 v-else>Kami akan mengirimkan link untuk ganti password ke
          <a href="#">{{theEmail}}</a>,
          ikuti petunjuk yang kami kirimkan untuk mengganti password.</h4>
      </div>
      <div v-else-if="regState === 0">
        <h3>Daftar</h3>
        <h4>Masukan alamat email untuk melanjutkan.</h4>
      </div>
      <div v-else-if="regState === 1">
        <h3>Verifikasi Email</h3>
        <h4>Kita telah mengirimkan kode verifikasi ke email kamu.</h4>
      </div>
      <div v-else-if="regState === 2">
        <h3>Informasi Pribadi</h3>
        <h4>Masukan nama kamu dan no. telp. untuk akun baru.</h4>
      </div>
      <div v-else-if="regState === 3">
        <h3>Buat Password</h3>
        <h4>Buat password baru minimal 8 karakter untuk kamu masuk.</h4>
      </div>
      <div class="forgotCnt" v-if="type === 'forgot'">
        <button class="cancelBtn" v-on:click="type = 'login'"
          v-if="!sendingEmail">Kembali</button>
        <button :class="{okBtn: 1, disabled: sendingEmail}"
          v-on:click="doForgotPwd">
          <span v-if="sendingEmail">Mengirimkan email...</span>
          <span v-else-if="emailSent">Kirim Ulang</span>
          <span v-else>Kirimkan Email</span>
        </button>
      </div>
      <form v-on:submit.prevent="handleSubmit" v-else>
        <div class="theEmail" v-if="theEmail && loginState === 'pwd'">
          <h4>{{theEmail}}</h4>
          <div class="chEmail" v-on:click="loginState = 'email'">Change email</div>
        </div>
        <div v-if="(type === 'login' && loginState === 'email')
          || (type !== 'login' && regState === 0)"
          :class="{fieldGroup: true, hasError: form.email.error}">
          <input type="text" v-model="form.email.model" class="field"
          placeholder="Email" v-on:input="fieldChanged('email')">
          <div class="fieldError" v-if="form.email.error">
            {{form.email.error}}
          </div>
        </div>
        <div :class="{fieldGroup: true, hasError: form.pwd.error}"
          v-if="type === 'login' && loginState === 'pwd'">
          <div class="fieldCnt">
            <input :type="form.pwd.type" class="field" placeholder="Password"
              v-model="form.pwd.model" v-on:input="fieldChanged('pwd')"
              ref="pwd">
            <div :class="{showPwd: true, show: form.pwd.type === 'text'}"
              v-on:click="form.pwd.type = (form.pwd.type === 'text') ? 'password' : 'text'"></div>
          </div>
          <div class="fieldError" v-if="form.pwd.error">
            {{form.pwd.error}}
          </div>
        </div>
        <div v-if="type === 'register'">
          <div :class="{fieldGroup: true, hasError: form.code.error}"
            v-if="regState === 1">
            <input type="number" class="field" placeholder="Kode Verifikasi"
              v-model="form.code.model" v-on:input="fieldChanged('code')">
            <p class="hint">Masukan kode yang kami kirimkan ke email kamu.</p>
            <div class="fieldError" v-if="form.code.error">
              {{form.code.error}}
            </div>
          </div>
          <div v-if="regState === 2">
            <div :class="{fieldGroup: true, hasError: form.name.error}">
              <input type="text" class="field" placeholder="Nama lengkap"
                v-model="form.name.model" v-on:input="fieldChanged('name')">
              <div class="fieldError" v-if="form.name.error">
                {{form.name.error}}
              </div>
            </div>
            <div :class="{fieldGroup: true, hasError: form.phone.error}">
              <div class="fieldCnt hasPrefix">
                <input type="text" class="field" placeholder="No. Telp."
                  v-model="form.phone.model">
                <div class="prefix">+62</div>
              </div>
            </div>
            <div :class="{fieldGroup: true, hasError: form.pwd.error}">
              <div class="fieldCnt">
                <input :type="form.pwd.type" class="field" placeholder="Password"
                  v-model="form.pwd.model" v-on:input="fieldChanged('pwd')">
                <div :class="{showPwd: true, show: form.pwd.type === 'text'}"
                  v-on:click="form.pwd.type = (form.pwd.type === 'text') ?
                  'password' : 'text'"></div>
              </div>
              <div class="fieldError" v-if="form.pwd.error">
                {{form.pwd.error}}
              </div>
            </div>
          </div>
        </div>
        <div class="forgotPwd" v-if="type === 'login' && loginState === 'pwd'"
          v-on:click="type = 'forgot'">
          Lupa password?</div>
        <div class="btnCnt">
          <button :class="{loading: loading}">
            <span v-if="type === 'login'">Masuk</span>
            <span v-else-if="regState === 2">Selesaikan Pendaftaran</span>
            <span v-else>Berikutnya</span>
          </button>
        </div>
        <div class="clear"/>
        <div class="reg" v-if="type === 'login' || regState === 0"
          v-on:click="type = (type === 'login') ? 'register' : 'login'" >
          <span v-if="type === 'login'">
            Belum punya akun? <b>Daftar disini</b>
          </span>
          <span v-else>
            Sudah punya akun? <b>Masuk disini</b>
          </span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      type: 'login',
      regState: 0,
      loading: false,
      loginState: 'email',
      sendingEmail: false,
      emailSent: false,
      theEmail: '',
      form: {
        email: { model: '', error: null },
        pwd: { model: '', error: null, type: 'password' },
        code: { model: '', error: null },
        name: { model: '', error: null },
        phone: { model: '', error: null },
      },
    };
  },
  methods: {
    back() {
      if (this.regState === 0) {
        this.type = 'login';
        return;
      }
      this.regState -= 1;
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
    regNow() {
      this.loading = true;
      this.$http.post(this.$config.uri('user/register/finish'), {
        email: this.form.email.model,
        code: this.form.code.model,
        name: this.form.name.model,
        phone: this.form.phone.model,
        pwd: this.form.pwd.model,
      }).then((response) => {
        if (response.status !== 200) {
          this.name.error = 'Internal server error.';
          return;
        }
        setTimeout(() => {
          this.loginNow();
        });
      });
    },
    doForgotPwd() {
      if (this.sendingEmail) return;
      this.sendingEmail = true;
      this.$http.post(this.$config.uri('user/forgot/pwd'), {
        email: this.theEmail,
      }).then((response) => {
        this.sendingEmail = false;
        this.emailSent = true;
      });
    },
    verifyEmail(email, code, next) {
      this.$http.post(this.$config.uri('user/verify/email'), {
        email, code,
      }).then((response) => {
        next(response.data);
      });
    },
    regEmail(email, next) {
      this.$http.post(this.$config.uri('user/register/email'), { email }).then((r) => {
        next(r.data);
      });
    },
    poe(email, next) {
      this.$http.post(this.$config.uri('user/verify/poe'), { user: email }).then((r) => {
        if (r.data.status === 200) {
          this.theEmail = r.data.poe;
        }
        next(r.data.status === 200);
      });
    },
    loginNow() {
      this.$http.post(this.$config.uri('user/signin'), {
        user: this.form.email.model,
        password: this.form.pwd.model,
      }).then((response) => {
        if (response.data.status !== 200) {
          this.form.pwd.error = 'Password yang kamu masukan salah.';
          return;
        }

        this.$session.start();
        this.$session.set('name', response.data.user.name);
        this.$session.set('email', response.data.user.email);
        this.$session.set('role', response.data.user.role);
        this.$session.set('avatar', response.data.user.avatar);
        this.$session.set('jwt', response.data.token);
        window.location.reload();
      });
    },
    handleSubmit() {
      if (this.loading) return;
      if (this.type === 'login') {
        if (this.loginState === 'email') {
          if (this.form.email.model === '') {
            this.form.email.error = 'Mohon masukan alamat email kamu.';
            return;
          }
          this.loading = true;
          this.poe(this.form.email.model, (result) => {
            this.loading = false;
            if (!result) {
              this.form.email.error = 'Alamat email tidak derdaftar.';
              return;
            }
            this.loginState = 'pwd';
            setTimeout(() => {
              this.$refs.pwd.focus();
            });
          });
        } else {
          this.loginNow();
        }
      } else {
        switch (this.regState) {
          case 0:
            if (this.form.email.model === '') {
              this.form.email.error = 'Mohon masukan alamat email kamu.';
              return;
            }
            this.loading = true;
            this.regEmail(this.form.email.model, (result) => {
              this.loading = false;
              if (result.status !== 200) {
                this.form.email.error = result.message;
                return;
              }
              this.regState += 1;
            });
            break;
          case 1:
            if (this.form.code.model === '') {
              this.form.code.error = 'Mohon masukan kode verifikasi.';
              return;
            }
            this.loading = true;
            this.verifyEmail(this.form.email.model, this.form.code.model, (result) => {
              this.loading = false;
              if (result.status !== 200) {
                this.form.code.error = 'Kode verifikasi salah.';
                return;
              }
              this.regState += 1;
            });
            break;
          case 2:
            if (this.form.name.model === '') {
              this.form.name.error = 'Mohon masukan nama kamu.';
              return;
            }
            if (this.form.pwd.model.length < 8) {
              this.form.pwd.error = 'Password minimal 8 karakter.';
              return;
            }
            this.regNow();
            break;
          default: break;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fieldGroup{
  text-align: left;
}
.signInRequired{
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-height: 640px) {
    display: block;
    padding: 40px 0;
  }
  .signInCnt{
    width: 320px;
    margin: 0 auto;
    text-align: center;
    .logo{
      height: 34px;
    }
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-image: url(../assets/arrow-back.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .2s ease;
      margin-left: -8px;
      opacity: .7;
      &:hover{
        background-color: #eee;
        opacity: 1;
      }
    }
    h3{
      font-size: 30px;
      font-weight: normal;
      font-weight: 600;
      margin: 0 0 4px;
      line-height: 1.2;
    }
    h4{
      font-weight: normal;
      margin: 0 0 20px;
      color: #767676;
      line-height: 1.2;
    }
    .forgotHeader{
      text-align: left;
      h3{
        margin-bottom: 10px;
      }
      h4{
        color: #444;
        font-size: 17px;
      }
    }
    .forgotCnt{
      text-align: right;
      button{
        height: 44px;
        border: none;
        border-radius: 5px;
        padding: 0 16px;
        font-size: 17px;
        font-weight: bold;
        box-sizing: border-box;
        cursor: pointer;
        outline: 0;
        transition: all .3s ease;
        color: #444;
        background-color: #fff;
        &:hover{
          background-color: #eee;
        }
        &.okBtn{
          margin-left: 10px;
          background-color: #0d855d;
          color: #fff;
          &:hover{
            background-color: #11b981;
            box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.3);
          }
          &.disabled{
            background-color: #ddd;
            color: #999;
            box-shadow: none !important;
            cursor: default;
          }
        }
      }
    }
    form{
      .theEmail{
        margin: -10px 0 16px;
        h4{
          margin: 0;
          border: #a9e4ee 1px solid;
          padding: 4px 10px;
          border-radius: 50px;
          display: inline-block;
          line-height: 1.2;
          color: #555;
          background-color: #f4feff;
        }
        .chEmail{
          color: #0d855d;
          font-weight: 500;
          width: 120px;
          padding: 2px 0;
          margin: 5px auto;
          border-radius: 50px;
          cursor: pointer;
          &:hover{
            background-color: #eee;
          }
        }
      }
      .forgotPwd{
        font-size: 15px;
        color: #0b845c;
        margin-top: -8px;
        cursor: pointer;
        margin-bottom: 8px;
        text-align: left;
        padding-left: 7px;
        font-weight: 500;
        &:hover{
          color: #0d855d;
        }
      }
      .btnCnt{
        padding-top: 16px;
        padding-top: 6px;
        text-align: right;
        button{
          background-color: #31c1f4;
          height: 44px;
          color: #fff;
          border: none;
          border-radius: 5px;
          padding: 0 14px;
          font-size: 17px;
          font-weight: bold;
          display: block;
          width: 100%;
          box-sizing: border-box;
          // box-shadow: 2px 2px 6px rgba(0,0,0,.2);
          cursor: pointer;
          outline: 0;
          transition: all .3s ease;
          background-size: 36px auto;
          background-position: center;
          background-repeat: no-repeat;
          &:hover{
            background-color: #1eb0e4;
            box-shadow: 2px 2px 6px rgba(0,0,0,.3);
          }
          &.loading{
            background-image: url(../assets/loading.svg);
            background-color: #ccc;
            color: #999;
            box-shadow: none;
            cursor: default;
            span{
              display: none;
            }
          }
        }
      }
      .reg{
        line-height: 1.2;
        padding-top: 14px;
        color: #0d855d;
        text-align: center;
        cursor: pointer;
        &:hover{
          color: #11b981;
        }
      }
      .socialSignIn{
        text-align: center;
        p{
          color: #767676;
          font-size: 15px;
        }
        button{
          background-color: #fff;
          height: 44px;
          color: #444;
          border: none;
          border-radius: 5px;
          padding: 0 14px;
          font-size: 16px;
          font-weight: bold;
          display: block;
          width: 100%;
          box-sizing: border-box;
          margin-bottom: 10px;
          box-shadow: 1px 1px 5px rgba(0,0,0,.1);
          text-align: left;
          padding-left: 50px;
          position: relative;
          cursor: pointer;
          outline: 0;

          opacity: .6;
          filter: grayscale(1);
          box-shadow: none !important;
          background-color: #eee;
          margin-bottom: 3px;
          cursor: default;
          span{
            float: right;
            color: #767676;
          }

          &:hover{
            box-shadow: 1px 1px 5px rgba(0,0,0,.2);
          }
          &:before{
            width: 26px; height: 26px;
            position: absolute;
            content: "";
            display: block;
            left: 12px; top: 9px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
    }
    &.register{
      padding-bottom: 20px;
      form{
        .btnCnt{
          padding-top: 6px;
        }
      }
    }
  }
}
</style>
